import { StoreMessageSource } from '../../Types/StoreTypes';

export const SET_MESSAGESOURCE = 'SET_MESSAGESOURCE';

export function setMessageSource(messageSource: StoreMessageSource) {
    return { type: SET_MESSAGESOURCE, payload: messageSource };
}
